export const taxRate = 1.1
export const daysInMonth = 30
export const daysInWeek = 7
export const allTargetAgeArray = [10, 20, 30, 40, 50, 60, 70, 80]
